import { useCallback, useState } from 'react';

type UsePaginationResult = {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  resultFrom: number;
  skip: number;
  getResultTo: (totalCount: number) => number;
};

const usePagination = (take: number): UsePaginationResult => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const skip = (currentPage - 1) * take;
  const resultFrom = skip + 1;
  const getResultTo = useCallback(
    (totalCount: number) => Math.min(resultFrom + take - 1, totalCount),
    [resultFrom, take]
  );
  return { currentPage, setCurrentPage, skip, resultFrom, getResultTo };
};

export default usePagination;
